/** Normalize dynogels/API industry rows to a flat shape. */
export function normalizeIndustryItem(item) {
	const attrs = item?.attrs || item || {};
	return {
		...attrs,
		name: attrs.name,
		order: attrs.order ?? 1,
		professions: attrs.professions || [],
		subs: attrs.subs || [],
		heardFromOptions: attrs.heardFromOptions || [],
	};
}

/** True when the industry has selectable roles (excludes Venue-style rows). */
export function industryHasProfessions(industry) {
	const professions = industry?.professions?.length ? industry.professions : industry?.subs;
	return Array.isArray(professions) && professions.length > 0;
}

export function sortIndustriesByOrder(industries = []) {
	return [...industries].sort((a, b) => (a.order || 0) - (b.order || 0));
}

export function getIndustryNames(industries = [], { excludeEmptyProfessions = false } = {}) {
	const sorted = sortIndustriesByOrder(industries);
	return sorted
		.filter(industry => !excludeEmptyProfessions || industryHasProfessions(industry))
		.map(industry => industry.name)
		.filter(Boolean);
}
